import React from 'react';

const StatsCard = ({ 
  title, 
  value, 
  change, 
  changeType = 'positive', 
  icon, 
  color = 'primary',
  loading = false,
  className = '' 
}) => {
  const colorClasses = {
    primary: 'from-primary-lightGreen to-primary-teaGreen',
    blue: 'from-primary-lightGreen to-primary-teaGreen',
    purple: 'from-purple-400 to-purple-600',
    orange: 'from-orange-400 to-orange-600',
    red: 'from-red-400 to-red-600',
    green: 'from-green-400 to-green-600',
  };

  const iconColorClasses = {
    primary: 'text-primary-black',
    blue: 'text-primary-black',
    purple: 'text-purple-600',
    orange: 'text-orange-600',
    red: 'text-red-600',
    green: 'text-green-600',
  };

  if (loading) {
    return (
      <div className={`stats-card ${className}`}>
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="loading-skeleton h-4 w-20 mb-2"></div>
            <div className="loading-skeleton h-8 w-16"></div>
          </div>
          <div className="w-12 h-12 loading-skeleton rounded-full"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`stats-card ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
          <p className="text-3xl font-bold text-primary-black mb-2">{value}</p>
          {change && (
            <div className="flex items-center">
              <span className={`text-sm font-medium ${
                changeType === 'positive' ? 'text-green-600' : 
                changeType === 'negative' ? 'text-red-600' : 'text-gray-600'
              }`}>
                {changeType === 'positive' ? '+' : changeType === 'negative' ? '-' : ''}{change}
              </span>
              <span className="text-sm text-gray-500 ml-1">vs last month</span>
            </div>
          )}
        </div>
        
        {icon && (
          <div className={`w-12 h-12 bg-gradient-to-br ${colorClasses[color]} rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
            <span className={`${iconColorClasses[color]} text-xl`}>
              {icon}
            </span>
          </div>
        )}
      </div>
      
      {/* Progress bar */}
      <div className="mt-4">
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div 
            className={`bg-gradient-to-r ${colorClasses[color]} h-2 rounded-full transition-all duration-1000`}
            style={{ width: `${Math.min(100, Math.max(0, change || 0))}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
